import { ChevronLeft, ChevronRight } from "@monta/icons";
import clsx from "clsx";
import { useBreakLG } from "../../utils";
import styles from "./styles.module.scss";

const Navigation = (props: {
  onPageChange: (page: number) => void;
  totalCount: number;
  currentPage: number;
  pageSize: number;
}) => {
  const { onPageChange, totalCount, currentPage, pageSize } = props;
  const isLg = useBreakLG();
  const totalPageCount = Math.ceil(totalCount / pageSize);
  const isLastPage = Boolean(totalPageCount == currentPage);

  const onNext = () => {
    if (!(isLastPage || totalPageCount === 0)) onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage != 1) onPageChange(currentPage - 1);
  };

  return (
    <div className={clsx(styles["navigation-container"])}>
      <div
        onClick={onPrevious}
        className={clsx(
          styles["navigation-container__arrows"],
          currentPage === 1 && styles["navigation-container__arrows--disabled"],
        )}
      >
        <ChevronRight color={!isLg ? "#FF6A00" : "#1D2939"} size={"16px"} />
        <span>قبلی</span>
      </div>
      <div
        className={clsx(styles["navigation-container__text"])}
      >{`صفحه ${currentPage} از ${totalPageCount}`}</div>
      <div
        onClick={onNext}
        className={clsx(
          styles["navigation-container__arrows"],
          (isLastPage || totalPageCount === 0) &&
            styles["navigation-container__arrows--disabled"],
        )}
      >
        <span>بعدی</span>
        <ChevronLeft color={!isLg ? "#FF6A00" : "#1D2939"} size={"16px"} />
      </div>
    </div>
  );
};

export default Navigation;
